import { AMERICAN_FAMILY_ORG } from "@remi/types/organizations";

import { hasCapability, type User } from "../base";
import { NON_EXISTENT_NUMERIC_ID } from "../utils/types";

export const requestForQuote = {
  read: (user: User) => hasCapability(user, "requestForQuote.read"),
  create: (user: User) =>
    hasCapability(user, "requestForQuote.create") || user.person.organizationId === AMERICAN_FAMILY_ORG.id,
  update: (user: User) => hasCapability(user, "requestForQuote.update"),
  forceUpdate: (user: User) => hasCapability(user, "requestForQuote.forceUpdate"),
};

type RequestForQuoteScopeClause =
  | { bid: { bidProject: { organizations: { some: { organizationId: string; deletedAt: null } } } } }
  | { bid: { workSite: { homeownerId: string } } };

export const requestForQuoteWhere = (user: User) => {
  if (hasCapability(user, "requestForQuote.read.all")) {
    return {};
  }

  const clauses: RequestForQuoteScopeClause[] = [];

  if (hasCapability(user, "requestForQuote.read.org")) {
    clauses.push({
      bid: {
        bidProject: {
          organizations: {
            some: {
              organizationId: user.person.organizationId,
              deletedAt: null,
            },
          },
        },
      },
    });
  }
  if (hasCapability(user, "requestForQuote.read.owned")) {
    clauses.push({
      bid: {
        workSite: {
          homeownerId: user.person.id,
        },
      },
    });
  }

  if (clauses.length === 0) {
    return { AND: [{ id: NON_EXISTENT_NUMERIC_ID }] };
  }
  return { OR: clauses };
};
